import ErrorScreen from './errorScreen.ui';

export default ErrorScreen;
